<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px">
      <!-- 담당자 찾기 화면 -->
      <!-- <v-card flat v-if="ShowNum == 1">
        <v-tabs class="ml-n2">
          <v-tab center-active class="ml-4 text-subtitle-1 font-weight-bold"> {{cLabel}} </v-tab>
        </v-tabs>
        <v-divider class="ml-2 mr-2"></v-divider>

        <v-card-text class="mt-2">
          <div style="height:80px">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="cNowSearchkeyWord"
                  @keyup.enter="GetChargeInfo()"
                  @click:append="GetChargeInfo()"
                  :placeholder="cPlaceHolder"
                  label="검색어"
                  class="mr-8"
                  append-icon="search"
                  persistent-placeholder
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
          
          <div style="height:calc(80vh - 230px);">
            <v-data-table
              :items="Records"
              :headers="headers"
              :single-select="bSingleSelect"
              v-model="selected"
              @click:row="handleClick"
              @dblclick:row="handleDoubleClick"
              fixed-header
              show-select
              item-key="cUserId"
              height="calc(80vh - 280px)"
            >
              <template v-slot:item.data-table-select="{ isSelected }">
                <v-icon class="ml-1" v-if="isSelected">done</v-icon>
              </template>
              <template v-slot:no-data>
                <div class="black--text">{{cNoMsg}}</div>
              </template>
            </v-data-table>
          </div>
          <v-divider class="mt-8"></v-divider>
        </v-card-text>
        <div class="ml-7 text-caption">* 해당항목을 더블클릭으로 선택하세요.</div>
        <v-divider class="ml-6 mr-6 mt-4"></v-divider>
        <v-card-actions class="pb-3 pr-4">
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false;" width="90px" text class="ml-2"><v-icon class="mr-2">mdi-close</v-icon>닫기</v-btn>
          <v-btn @click="handleDoubleClick()" width="90px" dark class="mr-2"><v-icon class="mr-2">mdi-check</v-icon>확인</v-btn>
        </v-card-actions>
      </v-card> -->


      <!-- 관리자 찾기 화면 -->
      <!-- <v-card flat v-if="ShowNum == 2">
        <v-tabs class="ml-n2">
          <v-tab center-active class="ml-4 text-subtitle-1 font-weight-bold"> {{cLabel}} </v-tab>
        </v-tabs>
        <v-divider class="ml-2 mr-2"></v-divider>
        <v-card-text class="mt-2">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="cNowSearchkeyWord"
                @keyup.enter="GetManagerInfo()"
                @click:append="GetManagerInfo()"
                :placeholder="cPlaceHolder"
                label="검색어"
                class="mr-8"
                append-icon="search"
                persistent-placeholder
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>

          <div style="height:calc(80vh - 230px);">
            <v-data-table
              :items="Records1"
              :headers="headers1"
              :single-select="true"
              show-select
              v-model="selected"
              @click:row="handleClick"
              @dblclick:row="handleDoubleClick"
              item-key="cCustomId"
              fixed-header
              height="calc(80vh - 280px)"
            >
              <template v-slot:item.data-table-select="{ isSelected }">
                <v-icon class="ml-0 pl-0" v-if="isSelected">done</v-icon>
              </template>
              <template v-slot:no-data>
                <div class="black--text">{{cNoMsg}}</div>
              </template>
            </v-data-table>
          </div>
          <v-divider class="mt-8"></v-divider>
        </v-card-text>
        <div class="ml-7 text-caption">* 해당항목을 더블클릭으로 선택하세요.</div>  
        <v-divider class="ml-6 mr-6 mt-4"></v-divider>
        <v-card-actions class="pb-3 pr-4">
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false;" width="90px" text class="ml-2"><v-icon class="mr-2">mdi-close</v-icon>닫기</v-btn>
          <v-btn @click="handleDoubleClick()" width="90px" dark class="mr-2"><v-icon class="mr-2">mdi-check</v-icon>확인</v-btn>
        </v-card-actions>
      </v-card> -->


      <!-- 분실자 찾기 화면 -->
      <v-card v-if="ShowNum == 3">
        <v-tabs class="ml-n2">
          <v-tab center-active class="ml-4 text-subtitle-1 font-weight-bold"> {{cLabel}}</v-tab>
        </v-tabs>
        <v-divider class="ml-2 mr-2"></v-divider>

        <v-card-text class="mt-2">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="cNowSearchkeyWord"
                @keyup.enter="GetLostCustomInfo()"
                @click:append="GetLostCustomInfo()"
                :placeholder="cPlaceHolder"
                label="검색어"
                class="mr-8"
                style="max-width:210px;"
                append-icon="search"
                persistent-placeholder
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>

          <div style="height:calc(80vh - 230px);">
            <v-data-table
              :items="Records2"
              :headers="headers2"
              :single-select="bSingleSelect"
              show-select
              v-model="selected"
              @click:row="handleClick"
              @dblclick:row="handleDoubleClick"
              item-key="cPassMappingId"
              height="calc(80vh - 280px)"
            >
              <template v-slot:item.data-table-select="{ isSelected }">
                <v-icon class="ml-1" v-if="isSelected">done</v-icon>
              </template>
              <template v-slot:no-data>
                <div class="black--text">{{cNoMsg}}</div>
              </template>
            </v-data-table>
          </div>
          <v-divider class="mt-2"></v-divider>
        </v-card-text>
        <div class="ml-7 text-caption">* 해당항목을 더블클릭으로 선택하세요.</div>  
        <v-divider class="ml-6 mr-6 mt-4"></v-divider>
        <v-card-actions class="pb-3 pr-4">
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false;" width="90px" text class="ml-2"><v-icon class="mr-2">mdi-close</v-icon>닫기</v-btn>
          <v-btn @click="handleDoubleClick()" width="90px" dark class="mr-2"><v-icon class="mr-2">mdi-check</v-icon>확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";

export default {
  components: {
  },
  data: () => ({
    cNowSearchkeyWord : "", /* 검색한 담당자 OR 관리자 이름 */
    cNoMsg : "",
    dialog : false,
    ShowNum : 0,
    bSingleSelect : true,
    oChargeCustom : {
      cChargeCustomTel : "",
      cChargeCustomNm : "",
    },
    selected : [],
    // Records : [],
    Records1 : [],
    Records2 : [],
    // headers: [
    //   { text: '담당자 이름', align: 'center', value: 'cUserNm'},
    //   { text: '담당자 부서', value: 'cPartNm'},
    //   { text: '직급', value: 'cPartLev'},
    // ],
    headers1: [
      { text: '직원 이름', align: 'center', value: 'cCustomNm'},
      { text: '이메일', value: 'cEmail'},
      { text: '전화번호', value: 'cTel'},
      { text: '대표전화번호', value: 'cPresentTel'},
    ],
    headers2 : [
      { text: '분실자 이름', align: 'center', value: 'cCustomNm'},
      { text: '방문증 번호', value: 'cPassNm'},
      { text: '분실자 전화번호', value: 'cTel'},
    ],
  }),
  computed: {  
    ...mapState(["CustomInfo"]),
    cLabel() {
      if (this.ShowNum == 1) {
        return "담당자 찾기"
      } else if (this.ShowNum == 2) {
        return "관리자 찾기"
      } else {
        return "방문증 분실자 찾기"
      }
      // return this.ShowNum == 1 ?"담당자 찾기":"관리자 찾기"
    },
    cPlaceHolder() {
      if (this.ShowNum == 1) {
        return "담당자 이름"
      } else if (this.ShowNum == 2) {
        return "관리자 이름"
      } else {
        return "분실자 이름"
      }
      // return this.ShowNum == 1 ?"담당자 이름":"관리자 이름"
    }
  },
  created() {
  },
  mounted() {
  },

  methods : {
    ShowDialog(ShowNum,NowSearchkeyWord){
      this.ShowNum = ShowNum
      this.dialog = true;
      this.selected = [];
      // this.Records = [];
      this.cNowSearchkeyWord = NowSearchkeyWord

      this.GetLostCustomInfo();

      // if (ShowNum == 1) {
      //   this.GetChargeInfo();
      // } else 
      // if (ShowNum == 2) {
      //   this.GetManagerInfo();
      // } else {
      //   this.GetLostCustomInfo();
      // }
    },

    // 데이터 테이블 내부 데이터 클릭 시
    handleClick(value) {
      this.selected = [value];
    },

    // 데이터 테이블 목록 두 번 클릭 시 실행 함수
    handleDoubleClick() {
      // if (this.selected.length == 0 && this.ShowNum == 1) return EventBus.$emit("onShowMsgBox","선택이 제대로 되지 않았습니다.",  "담당자를 선택 후 우측의 확인 버튼을 클릭해 주세요.");
      if (this.selected.length == 0 && this.ShowNum == 3) return EventBus.$emit("onShowMsgBox","선택이 제대로 되지 않았습니다.",  "분실자를 선택 후 우측의 확인 버튼을 클릭해 주세요.");
      if (this.selected.length > 0){
        this.dialog = false;
        // if (this.ShowNum == 1){
        //   this.$emit("SetCharge",this.selected);
        //   return
        // } else 
        this.$emit("SetLostCustom",this.selected,this.oChargeCustom);
        return
      }
    },

    // async handleDoubleClick() {
    //   // if (this.selected.length == 0 && this.ShowNum == 1) return EventBus.$emit("onShowMsgBox","선택이 제대로 되지 않았습니다.",  "담당자를 선택 후 우측의 확인 버튼을 클릭해 주세요.");
    //   if (this.selected.length == 0 && this.ShowNum == 2) return EventBus.$emit("onShowMsgBox","선택이 제대로 되지 않았습니다.",  "관리자를 선택 후 우측의 확인 버튼을 클릭해 주세요.");
    //   if (this.selected.length == 0 && this.ShowNum == 3) return EventBus.$emit("onShowMsgBox","선택이 제대로 되지 않았습니다.",  "분실자를 선택 후 우측의 확인 버튼을 클릭해 주세요.");
    //   if (this.selected.length > 0){
    //     this.dialog = false;
    //     // if (this.ShowNum == 1){
    //     //   this.$emit("SetCharge",this.selected);
    //     //   return
    //     // } else 
    //     if (this.ShowNum == 2){
    //       let res = await this.SetCorpManager();
    //       if (res.data.ResultCd == "00") {
    //         EventBus.$emit("onShowMsg",false,  "관리자 등록이 완료되었습니다.");
    //         this.$emit("SetManager",this.selected);
    //       } else {
    //         EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
    //       }
    //       return
    //     } else {
    //       this.$emit("SetLostCustom",this.selected);
    //       return
    //     }
    //   }
    // },

    // // 담당자 정보가져오기
    // GetChargeInfo(){
    //   var posData = {
    //     CustomId : this.CustomInfo.CustomId,
    //     ChargeUserNm : this.cNowSearchkeyWord,
    //   };
    //   axios
    //     .post(BasicInfo.UIL_API + "GetChargeInfo", posData, {
    //       headers: {
    //        "Authorization": this.CustomInfo.Token
    //       }
    //     })
    //     .then(res => {
    //       if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
    //       if (res.data.ResultCd === "00") {
    //         if (res.data.Result.length == 0) {
    //           this.cNoMsg = ""
    //           setTimeout(() => {
    //             this.cNoMsg = "조회결과가 없습니다."
    //           }, 300);
    //         }
    //         this.Records = res.data.Result
    //       } else {
    //         EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
    //       }
    //     })
    //     .catch(err => {
    //       EventBus.$emit("onShowMsg",true, ""+err);        
    //     });
    // },

    // // 관리자 추가하기
    // SetCorpManager(){
    //   var posData = {
    //     UpdateCustomId : this.CustomInfo.CustomId,
    //     CustomId : this.selected[0].cCustomId,
    //   }
    //   return new Promise((resolve) => (
    //     axios
    //     .post(BasicInfo.UIL_API + "SetCorpManager", posData, {
    //       headers: {
    //         "Authorization": this.CustomInfo.Token
    //       }
    //     })
    //     .then(res => {
    //       if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
    //       resolve(res);
    //     })
    //     .catch(err => {
    //       resolve(null);
    //       EventBus.$emit("onShowMsg", true,""+err);
    //     })
    //   ));
    // },

    // // 관리자 정보가져오기
    // GetManagerInfo(){
    //   var posData = {
    //     CorpId : this.CustomInfo.CorpId,
    //     CustomNm : this.cNowSearchkeyWord,
    //   };
    //   axios
    //     .post(BasicInfo.UIL_API + "GetManagerInfo", posData, {
    //       headers: {
    //        "Authorization": this.CustomInfo.Token
    //       }
    //     })
    //     .then(res => {
    //       if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
    //       if (res.data.ResultCd === "00") {
    //         if (res.data.Result.length == 0) {
    //           this.cNoMsg = ""
    //           setTimeout(() => {
    //             this.cNoMsg = "조회결과가 없습니다."
    //           }, 300);
    //         }
    //         this.Records1 = res.data.Result
    //       } else {
    //         EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
    //       }
    //     })
    //     .catch(err => {
    //       EventBus.$emit("onShowMsg",true, ""+err);        
    //     });
    // },

    // 분실자 정보가져오기
    GetLostCustomInfo(){
      var posData = {
        CorpId : this.CustomInfo.CorpId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        // Manager : this.CustomInfo.Manager,
        NowSearchKeyWord : this.cNowSearchkeyWord,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "GetLostCustomInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result1.length == 0) {
              this.cNoMsg = ""
              setTimeout(() => {
                this.cNoMsg = "조회결과가 없습니다."
              }, 300);
            }

            this.oChargeCustom = res.data.Result2[0]
            // this.oChargeCustom.cTel = res.data.Result2[0].cChargeCustomTel
            // this.oChargeCustom.cCustomNm = res.data.Result2[0].cChargeCustomNm
            if (this.oChargeCustom.cTel == "") {
              EventBus.$emit("onShowMsgBox", "소속업체의 정 관리자 정보가 없습니다.",  "소속업체에 문의하여 정 관리자 등록은 먼저 진행하여 주세요.");  
              return
            }

            this.Records2 = res.data.Result1
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>

<style lang="scss" scoped>
  .table_height {
    @media screen and (max-height: 935px){
      height : calc(100vh - 370px);
    }
    
    @media screen and (min-height: 936px){
      height : 550px;
    }

  }
</style>